import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export interface PayLaterBookingItem {
    paymentIntentId: string;
    userId: string;
    userName: string;
    courtName: string;
    locationName: string;
    startTime: string;
    endTime: string;
    amount: number;
    currency: string;
    gameType: string;
    sportType: string;
    status: string;
    gameId?: number;
}

export const GET_PAY_LATER_BOOKINGS_QUERY_KEY = (userId: string, charged?: boolean) =>
    ['payments', 'admin', 'users', userId, 'pay-later-bookings', charged];

export function useGetPayLaterBookings(userId: string, charged?: boolean) {
    const client = useApiClient();

    const params = new URLSearchParams();
    if (charged === true) params.set('charged', 'true');
    if (charged === false) params.set('charged', 'false');
    const query = params.toString();

    return useQuery({
        queryKey: GET_PAY_LATER_BOOKINGS_QUERY_KEY(userId, charged),
        queryFn: () =>
            client.fetchApi<PayLaterBookingItem[], {}>({
                endpoint: `payments/admin/users/${userId}/pay-later-bookings${query ? `?${query}` : ''}`,
                method: 'GET',
            }),
        enabled: Boolean(userId),
    });
}
